<template>
  <v-tooltip top v-if="isHaveModify">
    <template v-slot:activator="{ on }">
      <span v-on="on"
        ><v-icon small>{{ icon }}</v-icon></span
      >
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "RecordsModifiedItem",
  props: {
    slotData: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  computed: {
    isHaveModify() {
      return this.slotData.name in this.item;
    },
    isUserModify() {
      return this.item[this.slotData.name];
    },
    icon() {
      return this.isUserModify ? "mdi-account" : "mdi-server";
    },
    text() {
      return this.isUserModify
        ? this.$t("meter-units.created-or-edited-by-user")
        : this.$t("meter-units.created-by-server");
    }
  }
};
</script>

<style scoped></style>
